import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { FiEye, FiEyeOff, FiLogIn } from 'react-icons/fi';
import { FaCat } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { login } from '../../auth/auth';
import api from '../../services/api';
import { useToasts } from 'react-toast-notifications'

import './styles.css';

const Login = () => {
    const { addToast } = useToasts()
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [inputPassword, setInputPassword] = useState('password');

    const history = useHistory();

    async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault();

        api.post('login', { email, password }).then(response => {
            login(response.data.token, response.data.currentUser);
            history.push('/list/story');
        }).catch(e => {
            addToast(e.response.data.message, {
                appearance: 'error',
                autoDismiss: true,
            })
        });
    }

    return (
        <div id="page-home">
            <div className="content">
                <main>
                    <h1>Seu pet e melhor amigo.</h1>
                    <p>Ajudamos crianças a aprender de forma mais interativa e divertida.</p>

                    <Link to="/new/user">
                        <span>
                            <FaCat />
                        </span>
                        <strong>Cadastre seu Miaw</strong>
                    </Link>
                    <a href="#login-form" id="login-button">
                        <span>
                            <FiLogIn />
                        </span>
                        <strong>Já tem uma conta? Entrar</strong>
                    </a>
                </main>
            </div>
            <div>
                <form id="login-form" onSubmit={handleSubmit}>
                    <h1>Já tem uma conta?</h1>
                    <fieldset>
                        <legend>
                            <h2>Faça seu login!</h2>
                        </legend>
                        <div className="field">
                            <label htmlFor="email">
                                Seu email
                            </label>
                            <input
                                type="text"
                                placeholder="Digite seu email..."
                                id="email"
                                value={email}
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setEmail(e.currentTarget.value)}
                            />
                        </div>
                        <div className="field">
                            <label htmlFor="password">
                                Informe uma senha
                            </label>
                            <div>
                                <input
                                    type={inputPassword}
                                    placeholder="Digite sua senha..."
                                    id="password"
                                    value={password}
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setPassword(e.currentTarget.value)}
                                    style={{
                                        marginRight: 8
                                    }}
                                />
                                {inputPassword === 'password' ? (
                                    <i style={{
                                        cursor: 'pointer'
                                    }} onClick={() => setInputPassword('text')}><FiEye /></i>
                                ) : (
                                        <i style={{
                                            cursor: 'pointer'
                                        }} onClick={() => setInputPassword('password')}><FiEyeOff /></i>
                                    )}
                            </div>
                        </div>
                    </fieldset>
                    <button type="submit">Entrar</button>
                    <Link to="/password/recover">Esqueci minha senha</Link>
                </form>
            </div>
        </div>
    );
};

export default Login;
